import { useEffect, useRef } from "react";
import { MapContainer, TileLayer, Marker, Popup, Polyline, useMap } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

// Fix default Leaflet marker icons
const pickupIcon = new L.DivIcon({
  className: "",
  html: `<div style="width:28px;height:28px;background:#FF6B00;border-radius:8px;border:3px solid white;box-shadow:0 2px 8px rgba(0,0,0,0.2);display:flex;align-items:center;justify-content:center">
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="3"><circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="3" fill="white"/></svg>
  </div>`,
  iconSize: [28, 28],
  iconAnchor: [14, 14],
});

const deliveryIcon = new L.DivIcon({
  className: "",
  html: `<div style="width:28px;height:28px;background:#16a34a;border-radius:8px;border:3px solid white;box-shadow:0 2px 8px rgba(0,0,0,0.2);display:flex;align-items:center;justify-content:center">
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="3"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/><circle cx="12" cy="10" r="3" fill="white"/></svg>
  </div>`,
  iconSize: [28, 28],
  iconAnchor: [14, 14],
});

const agentIcon = new L.DivIcon({
  className: "",
  html: `<div style="width:32px;height:32px;background:#2563eb;border-radius:50%;border:3px solid white;box-shadow:0 2px 12px rgba(37,99,235,0.4);display:flex;align-items:center;justify-content:center">
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2.5"><rect x="1" y="3" width="15" height="13" rx="2"/><path d="M16 8h4l3 3v5h-7V8z"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>
  </div>`,
  iconSize: [32, 32],
  iconAnchor: [16, 16],
});

function FitBounds({ points }) {
  const map = useMap();
  const fitted = useRef(false);
  useEffect(() => {
    if (points.length >= 2 && !fitted.current) {
      const bounds = L.latLngBounds(points.map((p) => [p.lat, p.lng]));
      map.fitBounds(bounds, { padding: [40, 40], maxZoom: 14 });
      fitted.current = true;
    }
  }, [points, map]);
  return null;
}

export default function OrderMap({ pickup, delivery, agentLocation, className = "" }) {
  if (!pickup?.lat || !delivery?.lat) return null;

  const center = [(pickup.lat + delivery.lat) / 2, (pickup.lng + delivery.lng) / 2];
  const points = [pickup, delivery];
  if (agentLocation?.lat) points.push(agentLocation);

  const routeLine = [[pickup.lat, pickup.lng], [delivery.lat, delivery.lng]];

  return (
    <div className={`rounded-xl overflow-hidden border border-slate-200 ${className}`} data-testid="order-map">
      <MapContainer center={center} zoom={12} scrollWheelZoom={false} style={{ height: "100%", width: "100%", minHeight: 250 }}>
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OSM</a>'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <FitBounds points={points} />

        <Marker position={[pickup.lat, pickup.lng]} icon={pickupIcon}>
          <Popup><strong>Pickup</strong></Popup>
        </Marker>

        <Marker position={[delivery.lat, delivery.lng]} icon={deliveryIcon}>
          <Popup><strong>Delivery</strong></Popup>
        </Marker>

        {agentLocation?.lat && (
          <Marker position={[agentLocation.lat, agentLocation.lng]} icon={agentIcon}>
            <Popup><strong>Agent Location</strong></Popup>
          </Marker>
        )}

        <Polyline positions={routeLine} pathOptions={{ color: "#FF6B00", weight: 3, dashArray: "8 6", opacity: 0.7 }} />
      </MapContainer>
    </div>
  );
}
